import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';

export class DateUtil {
  static dateRange = (
    fromDate: dayjs.ConfigType,
    toDate: dayjs.ConfigType,
  ): Dayjs[] => {
    const startDate = dayjs(fromDate);
    const endDate = dayjs(toDate);
    const dates: Dayjs[] = [];
    for (let date = startDate; date <= endDate; date = date.add(1, 'day')) {
      dates.push(date);
    }
    return dates;
  };

  static dateRangeWithFormat = (
    fromDate: dayjs.ConfigType,
    toDate: dayjs.ConfigType,
  ): string[] => {
    return this.dateRange(fromDate, toDate).map((d) => d.format('YYYY-MM-DD'));
  };
}

// TODO: DateUtilを関数群に変更する
export function getDateRangeNum(fromDate: string, toDate: string): number {
  return dayjs(toDate).diff(fromDate, 'day') + 1;
}
